import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import States from "./pages/States";
import Districts from "./pages/Districts";
import Blocks from "./pages/Blocks";
import Schools from "./pages/Schools";
import Profile from "./pages/Profile";
import Users from "./pages/Users";
import Holidays from "./pages/Holidays";
import AssessmentYears from "./pages/AssessmentYears";
import Cycles from "./pages/Cycles";
import Competency from "./pages/Competency";
import CompetencyCategory from "./pages/CompetencyCategory";
import CompetencyHeader from "./pages/CompetencyHeader";
import CompetencySet from "./pages/CompetencySet";
import Sets from "./pages/Sets";
import AssessmentSimulator from "./pages/AssessmentSimulator";
import SyncLogs from "./pages/SyncLogs";
import RestoreCenter from "./pages/RestoreCenter";
import ContinuousAccelerationReport from "./pages/ContinuousAccelerationReport";
import StudentLevelReport from "./pages/StudentLevelReport";
import QLRReport from "./pages/QLRReport";
import { setKeycloak } from "./services/apiClient";

function App({ keycloak }) {
 setKeycloak(keycloak);

 const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
 try {
 return localStorage.getItem("sidebarCollapsed") === "true";
 } catch {
 return false;
 }
 });

 const toggleSidebar = () => {
 setSidebarCollapsed((prev) => {
 const next = !prev;
 try {
 localStorage.setItem("sidebarCollapsed", String(next));
 } catch {
 // ignore storage errors (private browsing, quota, etc.)
 }
 return next;
 });
 };

 return (
 <BrowserRouter>
 <div className="flex min-h-screen bg-[#f5f6f8]">
 <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
 <div
 className={`${
 sidebarCollapsed ? "ml-16" : "ml-60"
 } flex-1 flex flex-col min-h-screen min-w-0 transition-[margin] duration-200 ease-in-out`}
 >
 <Header />
 <main className="flex-1 min-w-0">
 <Routes>
 <Route path="/" element={<Navigate to="/dashboard" />} />
 <Route path="/dashboard" element={<Dashboard />} />
 <Route path="/master-data/states" element={<States />} />
 <Route path="/master-data/districts" element={<Districts />} />
 <Route path="/master-data/blocks" element={<Blocks />} />
 <Route path="/master-data/schools" element={<Schools />} />
 <Route path="/master-data/assessment-years" element={<AssessmentYears />} />
 <Route path="/master-data/holidays" element={<Holidays />} />
 <Route path="/master-data/competency-sets" element={<CompetencySet />} />
 <Route path="/competency/list" element={<Competency />} />
 <Route path="/competency/category" element={<CompetencyCategory />} />
 <Route path="/competency/header" element={<CompetencyHeader />} />
 <Route path="/competency" element={<Navigate to="/competency/list" />} />
 <Route path="/master-data" element={<Navigate to="/master-data/states" />} />
 <Route path="/question-bank/sets" element={<Sets />} />
 <Route path="/question-bank/simulator" element={<AssessmentSimulator />} />
 <Route path="/question-bank" element={<Navigate to="/question-bank/sets" />} />
 <Route path="/profile" element={<Profile />} />
 <Route path="/user-management/users" element={<Users />} />
 <Route path="/cycles/quarterly" element={<Cycles key="quarterly" cycleType="quarterly" />} />
 <Route path="/cycles/continuous" element={<Cycles key="continuous" cycleType="continuous" />} />
 <Route path="/user-management" element={<Navigate to="/user-management/users" />} />
 <Route path="/sync-logs" element={<SyncLogs />} />
 <Route path="/restore-center" element={<RestoreCenter />} />
 <Route path="/reporting/continuous-acceleration" element={<ContinuousAccelerationReport />} />
 <Route path="/reporting/student-level" element={<StudentLevelReport />} />
 <Route path="/quarterly/qlr" element={<QLRReport />} />
 <Route path="/reporting" element={<Navigate to="/reporting/continuous-acceleration" />} />
 </Routes>
 </main>
 </div>
 </div>
 </BrowserRouter>
 );
}

export default App;
